import { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { logEvent } from 'firebase/analytics';

import { episodeList, programMenuList } from '@/network/apis/apiUri';
import analytics from '@/routes/firebase';
import VideoThumbnail from '@/components/video-thumnail';

export default function SlideBox({ mode, programId, anchorTitle }) {
  const observerRef = useRef();
  const [visible, setVisible] = useState(false);

  const { isSuccess, data } = useQuery(
    ['main', 'most-popular', 'program', programId],
    async () => {
      const menu = await programMenuList({
        program_id: programId,
        lan_code: mode,
      });

      const episode = menu.data.item.find((menu) => menu.type === 'episode');

      if (episode) {
        const list = await episodeList({
          lan_code: mode,
          board_id: episode.board_id,
          type: 'vod',
          reg_order: ' desc',
          page_info: { row_count: 20, number: 0 },
        });

        return list.data.item.map((item) => ({
          id: item.board_item_id,
          episodeId: item.episode_id,
          title: item.title,
          broadcast: item.broadcast_date.slice(0, 10),
          image: item.image_url,
          duration: item.duration,
          link: `/tv/${programId}/archive?board=${item.board_id}&id=${item.episode_id}&sort=episode`,
        }));
      }

      throw new Error('No Data');
    },
    {
      retry: false,
      enabled: !!programId && !!mode,
      staleTime: 1000 * 60 * 3,
    }
  );

  useEffect(() => {
    let observe = null;

    if (!visible && observerRef.current) {
      observe = new IntersectionObserver(([entry], observer) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      });

      observe.observe(observerRef.current);
    }
    return () => {
      if (observe) {
        observe.disconnect();
      }
    };
  }, []);

  const isComplete = isSuccess && visible && data;

  return (
    <div ref={observerRef} className="swiper-warpper">
      {isComplete && (
        <Swiper slidesPerView={5} spaceBetween={32} loop navigation>
          {data.map((item) => (
            <SwiperSlide key={`slide-box_${item.id}`}>
              <Link
                to={item.link}
                title={anchorTitle}
                onClick={() =>
                  logEvent(analytics, 'select_item', {
                    item_list_name: `${item.title}`,
                    item_list_id: `episode_${item.episodeId}`,
                    items: [
                      {
                        item_id: `${item.episodeId}`,
                        item_name: `${item.title}`,
                        item_brand: 'episode',
                      },
                    ],
                  })
                }
              >
                <div className="program-item">
                  <div className="image-container">
                    <VideoThumbnail thumbnail={item.image} duration={item.duration} />
                  </div>
                  <div className="program-title-box">
                    <h3>{item.title}</h3>
                    <time className="time-fs-fixed">{item.broadcast}</time>
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
}
